import { render, staticRenderFns } from "./WxAppDetail.vue?vue&type=template&id=57c71a59"
import script from "./WxAppDetail.vue?vue&type=script&lang=js"
export * from "./WxAppDetail.vue?vue&type=script&lang=js"
import style0 from "./WxAppDetail.vue?vue&type=style&index=0&id=57c71a59&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports